import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-24" data-testid="page-not-found">
      <div className="text-center max-w-md">
        <div className="font-mono text-xs text-[#e63946] tracking-[0.3em] uppercase">
          404
        </div>
        <h1 className="font-display text-4xl uppercase mt-4 tracking-tighter">
          Page not found
        </h1>
        <p className="text-zinc-400 mt-3 text-sm">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link to="/" className="btn-primary mt-7 inline-flex" data-testid="not-found-home-link">
          Back to home
        </Link>
      </div>
    </div>
  );
}
